import { Alert, Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useFriendship from '../../../pages/user/friendship/hooks/useFriendship';
import React, { useEffect } from 'react';
import { FriendDetails } from '../../../types/user/friendship';
import { Link } from 'react-router-dom';
import { useUser } from '../../../hooks';
import useLastFriends from '../../../pages/user/friendship/hooks/useLastFriends';

interface ProfileFriendListProps {
    username: string;
}

const ProfileFriendsList = ({ username }: ProfileFriendListProps) => {
    const { t } = useTranslation();

    const { lastFriends, friendsCount } = useLastFriends();
    const { loadLastFriends, loadFriendsCount } = useFriendship();
    const { userInfo, userLoadInfo, isUserAuthenticated } = useUser();

    useEffect(() => {
        if (username) {
            loadLastFriends(username);
            loadFriendsCount(username);
        }
    }, [username]);

    useEffect(() => {
        if (!userInfo && isUserAuthenticated) userLoadInfo();
    }, [userInfo]);

    return (
        <Card>
            <Card.Title className={'card-header bg-primary text-white text-uppercase my-0'}>
                <Row>
                    <Col className={'align-items-center'}>
                        {friendsCount !== null && (
                            <span className='float-start text-white text-uppercase mt-1'>
                                {t('friendship.friends_label')} ({friendsCount})
                            </span>
                        )}
                        {userInfo && (
                            <Link to={`/profile/${username}/friends`} title='Vezi toti prietenii' className='text-white btn-link float-end pr-2'>
                                <i className='mdi font-26 mdi-account-multiple'></i>
                            </Link>
                        )}
                    </Col>
                </Row>
            </Card.Title>
            <Card.Body>
                {lastFriends &&
                    lastFriends.length != 0 &&
                    lastFriends.map((friend: FriendDetails, index: number) => (
                        <div className='row py-1 align-items-center' key={index}>
                            <div className='col-auto'>
                                <img src={friend.details.avatarUrl} width='40px' height='40px' alt='' className='rounded-circle'></img>
                            </div>
                            <div className='col pl-0'>
                                <a className='text-body'>{friend.details.displayName}</a>
                                <p className='mb-0 text-muted'>
                                    <small>
                                        {friend.county == 'no_county' && t('friendship.no_county')}
                                        {friend.county != 'no_county' && friend.county}
                                    </small>
                                </p>
                            </div>
                            <div className='col-auto'>
                                <Link to={`/profile/${friend.details.username}`} className='btn btn-sm btn-link text-primary font-13'>
                                    <i className='mdi mdi-18px mdi-eye'></i>
                                </Link>
                            </div>
                        </div>
                    ))}
                {lastFriends && lastFriends.length === 0 && (
                    <Alert variant='info' className='mb-0 text-center'>
                        <h4 className='m-0 p-0'>{t('friendship.no_friends_profile')}</h4>
                    </Alert>
                )}
            </Card.Body>
        </Card>
    );
};

export default ProfileFriendsList;
